import * as classNames from 'classnames';
import { DataService } from '../../services/data_service';
import DialogWrapper2 from '../../core/dialog/dialog_wrapper_v2';
import { fn0nZ } from '../../core/formatter/formatNumber';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { InfoDialog } from '../../login/InfoDialog';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import style from './datenauswertung.less';
import { TriggerService } from '../../core/trigger/trigger_service';
import { WArchivIcon } from '../../core/elements/WArchivIcon';
import { WHelpIcon } from '../../core/elements/WHelpIcon';

interface EnergieCockpitHinweiseProps extends React.ClassAttributes<any> {
    data: any;
    jahr: number;
    onRoutingChange: (routing: any) => void;
}

interface EnergieCockpitHinweiseState {
    mouseOverIdx: number;
    keyInfo: string;
}

export class EnergieCockpitHinweise extends React.Component<EnergieCockpitHinweiseProps, EnergieCockpitHinweiseState> {

    constructor(props: any) {
        super(props);
        this.state = {
            mouseOverIdx: undefined,
            keyInfo: null
        };
        this.toggleGeleseneHinweiseAnzeigen = this.toggleGeleseneHinweiseAnzeigen.bind(this);
        this.toggleHinweis = this.toggleHinweis.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    prepareItems(hinweise_jahr: any[], jahr: number): any {
        return hinweise_jahr.map((hinweis: any) => {
            const type = hinweis.type;
            const value = hinweis.value;
            const status = hinweis.status;
            let icon = require(`../../img/${status ? 'energie_cockpit_unbekannt' : 'energie_cockpit_unbekannt_white'}.png`);
            let bgcolor = 'var(--color-section-main, #6c8b3f)';
            let width = 250;
            let content = <span>???</span>;
            let keyInfo: string = null;
            let routing: any = undefined;

            if (type === 'fehlt') {
                const isGefuehrterModus: boolean = (this.props.data[IDs.ENT_KONFIGURATION] || [])
                    .some((param: any) => param.gefuehrter_modus_orig === 1);
                if (isGefuehrterModus) {
                    return null;
                }
                icon = require(`../../img/${status ? 'energie_cockpit_fehlt' : 'energie_cockpit_fehlt_white'}.png`);
                content = <>
                    <span>
                        {i18n(value === 1
                            ? 'Es wurde {{1}} fehlende Dateneingabe für das Jahr {{2}} festgestellt'
                            : 'Es wurden {{1}} fehlende Dateneingaben für das Jahr {{2}} festgestellt', 'sys')
                            .replace('{{1}}', value).replace('{{2}}', jahr)
                        }
                        <br />
                    </span>
                    {(!isGefuehrterModus) && <>
                        <div className={style.speechBubbleLink} style={{ color: status ? '#606368' : 'white'/*'#6692c3', textDecoration: 'underline'*/ }}>{i18n('Anzeigen', 'sys')}&nbsp;🡒</div>
                    </>}
                </>;

                if (!isGefuehrterModus) {
                    routing = { path: { ...RoutingIDs.ROUTE_DATENEINGABE_EINGABEKONTROLLE, jahr } };
                } else {
                    routing = null;
                }
            }

            if (type === 'pv') {
                icon = require(`../../img/${status ? 'energie_cockpit_pv' : 'energie_cockpit_pv_white'}.png`);
                content = <>
                    <span>
                        {i18n('Mit einer Photovoltaikanlage könnten Sie durchschnittlich {{1}} € pro Jahr sparen!', 'sys').replace('{{1}}', value)}<br />
                    </span>
                    <div className={style.speechBubbleLink} style={{ color: status ? '#606368' : 'white'/*'#6692c3', textDecoration: 'underline'*/ }}>{i18n('Weitere Informationen', 'sys')}&nbsp;🡒</div>
                </>;
                routing = { path: RoutingIDs.ROUTE_ZUSATZTOOLS_PV };
            }

            if (type === 'co2') {
                icon = require(`../../img/${status ? 'energie_cockpit_co2' : 'energie_cockpit_co2_white'}.png`);
                content = <>
                    <span>
                        {i18n('Mehrkosten durch die CO₂-Bepreisung im Jahr {{1}} (Vgl. zu 2020): ca. {{2}} €.', 'sys').replace('{{1}}', jahr).replace('{{2}}', fn0nZ(value))}<br />
                    </span>
                    <div className={style.speechBubbleLink} style={{ color: status ? '#606368' : 'white'/*'#6692c3', textDecoration: 'underline'*/ }}>{i18n('Weitere Informationen', 'sys')}&nbsp;🡒</div>
                </>;
                routing = { path: RoutingIDs.ROUTE_ZUSATZTOOLS_CO2_TOOL };
            }

            if (type === 'steuer') {
                icon = require(`../../img/${status ? 'energie_cockpit_steuer' : 'energie_cockpit_steuer_white'}.png`);
                content = <>
                    <span>
                        <b>{i18n('Achtung', 'sys')}: </b>{i18n('Für das Jahr {{1}} besteht Anspruch auf Steuerrückerstattung!', 'sys').replace('{{1}}', jahr)}<br />
                    </span>
                    <div className={style.speechBubbleLink} style={{ color: status ? '#606368' : 'white'/*'#6692c3', textDecoration: 'underline'*/ }}>{i18n('Weitere Informationen', 'sys')}&nbsp;🡒</div>
                </>;
                routing = { path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_ENERGIESTEUER, jahr } };
            }

            if (type === 'steckbrief') {
                icon = require(`../../img/${status ? 'energie_cockpit_steckbrief' : 'energie_cockpit_steckbrief_white'}.png`);
                content = <>
                    <span>
                        {i18n('Die wichtigsten Einsparmaßnahmen für Ihr Gewerk finden Sie hier', 'sys')}:<br />
                    </span>
                    <WArchivIcon
                        module={IDs.MOD_ETOOL_ADMIN}
                        archivId={value}
                        hideIcon
                        hideFilename
                        title={
                            <span>
                                <div className={style.speechBubbleLink} style={{ color: status ? '#606368' : 'white'/*'#6692c3', textDecoration: 'underline'*/ }}>{i18n('Einsparpotentiale', 'sys')}&nbsp;🡒</div>
                            </span>
                        }
                        iconSize={24}
                    />
                </>;
            }

            if (type === 'umwelt' && value && value.bezeichnung && value.link) {
                icon = require(`../../img/${status ? 'energie_cockpit_umwelt' : 'energie_cockpit_umwelt_white'}.png`);
                content = <>
                    <span>
                        {i18n('Werden Sie mit dem E-Tool Teil', 'sys')} {value.bezeichnung}<br />
                    </span>
                    {typeof value.link === 'number' &&
                        <WArchivIcon
                            module={IDs.MOD_ETOOL_ADMIN}
                            archivId={value.link}
                            hideIcon
                            hideFilename
                            title={
                                <span>
                                    <div className={style.speechBubbleLink} style={{ color: status ? '#606368' : 'white'/*'#6692c3', textDecoration: 'underline'*/ }}>{i18n('Weitere Informationen', 'sys')}&nbsp;🡒</div>
                                </span>
                            }
                            iconSize={24}
                        />
                    }
                    {typeof value.link === 'string' &&
                        <span>
                            <a style={{ textDecoration: 'none' }} href={value.link} target='_blank'>
                                <div className={style.speechBubbleLink} style={{ color: status ? '#606368' : 'white'/*'#6692c3', textDecoration: 'underline'*/ }}>{i18n('Weitere Informationen', 'sys')}&nbsp;🡒</div>
                            </a>
                        </span>
                    }
                </>;
            }

            if (type === 'energieverbrauch') {
                icon = require(`../../img/${status ? 'energie_cockpit_fehlt' : 'energie_cockpit_fehlt_white'}.png`);
                content = <>
                    <span>
                        <b>{i18n('Achtung', 'sys')}: </b>{i18n('Ihr Gesamtenergieverbrauch übersteigt 2,5 GWh!', 'sys')}<br />
                    </span>
                    <div className={style.speechBubbleLink} style={{ color: status ? '#606368' : 'white'/*'#6692c3', textDecoration: 'underline'*/ }}>{i18n('Weitere Informationen', 'sys')}&nbsp;🡒</div>
                </>;
                // <WHelpIcon
                //     data={this.props.data}
                //     styleDivProps={{ display: 'inline-block' }}
                //     styleProps={{ backgroundColor: 'transparent', padding: 0 }}
                //     label='Energie Cockpit - Energieverbrauch'
                //     helpKey='energie_cockpit_hinweis_energieverbrauch'
                //     customElement={
                //         <div className={style.speechBubbleLink} style={{ color: status ? '#606368' : 'white'/*'#6692c3', textDecoration: 'underline'*/ }}>{i18n('Weitere Informationen', 'sys')}&nbsp;🡒</div>
                //     }
                //     style='custom'
                //     type='info'
                //     editBar
                //     useTheme
                // />
                keyInfo = i18n('Gesamtenergieverbrauch > 2,5 GWh pro Jahr', 'sys');
            }

            if (type === 'hinweis') {
                // icon = require('../../img/energie_cockpit_steckbrief.png');
                content = <span>{value}</span>;
                bgcolor = '#eee';
            }
            bgcolor = status ? '#dadada' : bgcolor;
            // Wir schleifen den Original-Datensatz als "hinweis"-Feld mit durch (wg. Speicherung)
            return { icon, content, routing, bgcolor, width, status, hinweis, keyInfo };
        });
    }

    render(): JSX.Element {
        const jahr = this.props.jahr;
        const hinweise = this.props.data[IDs.HINWEISE];
        const hinweise_jahr = hinweise && hinweise[jahr] ? hinweise[jahr] : [];
        const items = this.prepareItems(hinweise_jahr, jahr);

        return (
            <div
                style={{
                    borderTopRightRadius: 'var(--border-radius-headline)', borderTopLeftRadius: 'var(--border-radius-headline)',
                    boxShadow: 'var(--assistent-box-shadow)', display: 'flex', flexDirection: 'column'
                }}
            >
                <div
                    style={{
                        fontWeight: 600, fontSize: 'var(--font-size-headline)', backgroundColor: 'var(--color-bg-headline)',
                        maxHeight: 'var(--height-headline)', minHeight: 'var(--height-headline)', padding: '0 10px 0 20px',
                        borderTopRightRadius: 'var(--border-radius-headline)', borderTopLeftRadius: 'var(--border-radius-headline)',
                        display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'
                    }}
                >
                    {this.renderTitel()}
                </div>
                <div
                    style={{
                        backgroundColor: 'var(--color-wform-background, #f7f7f7)', minHeight: 140, paddingLeft: 20, boxSizing: 'border-box',
                        display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'left', alignItems: 'center', overflowX: 'auto'
                    }}
                >
                    {this.renderContent(items)}
                </div>
                {this.state.keyInfo && this.renderInfoDialog()}
            </div>
        );
    }

    renderContent(items: any[]): JSX.Element {
        const geleseneAusblenden: boolean = !!((this.props.data[IDs.ENT_KONFIGURATION] || [])
            .filter((param: any) => (param.gelesene_hinweise_ausblenden || null) === 'Ja').length);
        const itemsFiltered = items.filter((item: any) => item && (item.status !== 1 || !geleseneAusblenden));

        return <>{itemsFiltered.map((item: any, index: number) => this.renderItem(item, index))}</>;
    }

    renderHelpIcon(): JSX.Element {
        return (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ display: 'flex', alignSelf: 'center' }}
                styleProps={{ margin: 0 }}
                label={i18n('Energie Cockpit - Hinweise', 'sys')}
                helpKey='energie_cockpit_hinweise'
                type='theme_info'
                style='theme_small'
                customElement='Info'
                editBar
                useTheme
            />
        );
    }

    renderInfoDialog(): JSX.Element {
        const { keyInfo: name } = this.state;

        return (
            <DialogWrapper2
                title={name || ''}
                width={-1}
                onAfterClose={() => this.setState({ keyInfo: null })}
            >
                <InfoDialog name={name} />
            </DialogWrapper2>
        );
    }

    renderItem(item: any, index: number): JSX.Element {
        const hasInfo: boolean = !!item.keyInfo;
        const hasRouting: boolean = item.routing && item.routing !== ({} as any);
        const scaleStyle: any = this.state.mouseOverIdx === index ? { marginLeft: 5, marginRight: 5, transform: 'scale(1.1, 1.1)' } : {};

        return (
            <div
                key={`hinweis_outer-${index}`}
                className={classNames(style.speechBubble, item.status ? style.checked : null)}
                style={{ display: 'flex', flexDirection: 'column', height: 100, transition: 'all .2s ease', ...scaleStyle }}
                onMouseEnter={() => this.setState({ mouseOverIdx: index })}
                onMouseLeave={() => this.setState({ mouseOverIdx: undefined })}
            >
                {this.renderStatus(item)}
                <div
                    key={`hinweis-${index}`}
                    style={{
                        backgroundColor: item.bgcolor, width: item.width, minWidth: item.width, height: 80, marginRight: 30,
                        borderRadius: 10, boxSizing: 'border-box', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start',
                        cursor: hasRouting || hasInfo ? 'pointer' : undefined
                    }}
                    onClick={() => hasRouting
                        ? this.props.onRoutingChange(item.routing)
                        : (hasInfo ? this.setState({ keyInfo: item.keyInfo }) : null)
                    }
                >
                    <div style={{ width: 75, boxSizing: 'border-box', padding: 5 }}>
                        <img src={item.icon} alt='i' />
                    </div>
                    <div className={style.speechBubbleContent} style={{ color: item.status ? '#606368' : 'white'/*'#363f3f'*/ }}>
                        {item.content}
                    </div>
                </div>
            </div>
        );
    }

    renderStatus(item: any): JSX.Element {
        const color: string = item.status ? '#606368' : 'white';
        const backgroundColor: string = item.status ? '#dadada' : 'var(--color-section-main, #6c8b3f)';
        const iconStatus: string = require(`../../icons/theme/icon_bubble_${item.status ? 'checked' : 'unchecked'}.svg`);
        return (
            <div
                style={{
                    minWidth: 22, maxWidth: 22, minHeight: 22, maxHeight: 22, backgroundColor, color, textAlign: 'center', marginTop: -10,
                    marginBottom: -10, marginLeft: 240, fontSize: 12, cursor: 'pointer', borderRadius: 10, position: 'relative',
                    border: '2px solid #f7f7f7'
                }}
                onClick={() => this.toggleHinweis(item.hinweis)}>
                <img src={iconStatus} width={15} style={{ marginTop: 2 }} alt='i' />
            </div>
        );
    }

    /*renderStatus(item: any): JSX.Element {
        let color = '#666';
        let bgcolor = '#ddd';
        let text: any = <span>&#9432; <small>Info</small></span>;
        let cursor = '';

        if (item.status === 0) {
            color = '#a00';
            bgcolor = '#f79646';
            cursor = 'pointer';
            text = <span>&#9888; <small>Noch ungelesen</small></span>;
        }

        if (item.status === 1) {
            color = '#040';
            bgcolor = '#0a4';
            cursor = 'pointer';
            text = <span>&#10004; <small>Als gelesen markiert</small></span>;
        }
        return (
            <div
                style={{
                    height: 20, minWidth: item.width, width: item.width, backgroundColor: bgcolor, color: color, textAlign: 'center',
                    fontWeight: 'bold', fontSize: 12, cursor: cursor, borderBottomLeftRadius: 10, borderBottomRightRadius: 10
                }}
                onClick={() => this.toggleHinweis(item.hinweis)}>
                {text}
            </div>
        );
    }*/

    renderTitel(): JSX.Element {
        const geleseneAusblenden: boolean = !!((this.props.data[IDs.ENT_KONFIGURATION] || [])
            .filter((param: any) => (param.gelesene_hinweise_ausblenden || null) === 'Ja').length);

        return <>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <span style={{ marginRight: 5 }}>{i18n('Hinweise des E-Tools', 'sys')}</span>{this.renderHelpIcon()}
            </div>
            <div style={{ fontSize: 11, color: '#888', display: 'flex', alignItems: 'center' }}>
                {i18n('Gelesene Ausblenden', 'sys')}
                <input
                    type='checkbox'
                    checked={geleseneAusblenden}
                    onChange={(event: any) => this.toggleGeleseneHinweiseAnzeigen(event.target.checked ? 1 : 2)}
                />
            </div>
        </>;
    }

    toggleGeleseneHinweiseAnzeigen(value: number): void {
        const data = this.props.data;

        if (Array.isArray(data[IDs.ENT_KONFIGURATION]) && data[IDs.ENT_KONFIGURATION].length > 0) {
            const item: any = {
                tid: data[IDs.ENT_KONFIGURATION][0].tid,
                gelesene_hinweise_ausblenden: value
            };
            this.dataService.setData(IDs.MOD_ETOOL, IDs.ENT_KONFIGURATION, item, () => {
                this.triggerService.fire('reload', IDs.ENT_KONFIGURATION);
            });
        }
    }

    toggleHinweis(hinweis: any): void {
        if (hinweis.status === 2) {
            return; // Die einfache Hinweise speichern wir sowieso nie
        }
        const msg = hinweis.status === 0
            ? i18n('Als gelesen markieren?', 'sys')
            : i18n('Wieder als ungelesen markieren?', 'sys');

        if (!confirm(msg)) {
            return;
        }
        // jahresunabhängiger Status
        hinweis.status = (hinweis.status + 1) % 2; // Aus 1 mach 0 und andersherum
        const hinweis_save = {...hinweis};
        if (hinweis_save.type === 'umwelt') {
            hinweis_save.jahr = 0;
            hinweis_save.value = 1;
        }
        this.dataService.setData(
            IDs.MOD_ETOOL, IDs.ENT_ENERGIE_COCKPIT_HINWEISE, hinweis_save,
            () => this.triggerService.fire('reload', IDs.ENT_ENERGIE_COCKPIT_HINWEISE)
        );
    }
}
